export const aiSkipperPrompts = [
  {
    title: "Can I safely sail tomorrow?",
    context: "Weather, route exposure, vessel readiness, and crew risk review",
    response: "Check wind trend, sea state, visibility, alternate ports, and your vessel checklist before committing. Premium AI can combine these signals into a departure score."
  },
  {
    title: "Best anchorage protected from north wind?",
    context: "Wind direction, shelter geometry, seabed, swell wrap, and nearby services",
    response: "Look for southern-facing shelter, limited fetch, suitable holding ground, and a safe exit route if conditions shift."
  },
  {
    title: "Optimize fuel for my vessel type",
    context: "Distance, engine profile, reserve margin, sea state, and marina fuel stops",
    response: "Plan with conservative reserve margins, avoid high-current legs where possible, and compare marina stop options before departure."
  }
];

export const fleetOperationCards = [
  {
    title: "Vessel Readiness",
    metric: "92%",
    detail: "Maintenance, checklist, safety gear, and departure preparation status"
  },
  {
    title: "Route Risk",
    metric: "Moderate",
    detail: "Weather exposure, night navigation, traffic density, and alternate ports"
  },
  {
    title: "Operating Cost",
    metric: "$1,240",
    detail: "Fuel, marina stops, provisions, crew costs, and maintenance wear"
  },
  {
    title: "Crew & Safety",
    metric: "Ready",
    detail: "Role assignment, emergency plan, checklist completion, and communications"
  }
];

export const premiumWorkflowSteps = [
  "Choose vessel profile and operating constraints",
  "Select route, destination, or marina objective",
  "Review AI risk, weather, fuel, and safety intelligence",
  "Generate a practical skipper action plan",
  "Track trip, costs, checklist, and maintenance outcomes"
];